export default __webpack_public_path__ + "static/media/react.2d80508d.svg";